import { DocumentNode, gql } from "@apollo/client";
import { baseCategoryTaxonomy } from "./base";

// const ALL_CATEGORY_QUERY = `{
//     ... on TaxonomyTermCategory {
//         ${baseCategoryTaxonomy},
//         displayName: fieldName,
//         displayType: fieldDisplayType,
//         theme: fieldTheme,
//         faIcon: fieldFaIcon,
//         parentId: parentOfTaxonomyTermCategory {
//             entity {
//                 tid
//             }
//         }
//     }
// }
// `;

// const getAllCategoriesFilter = (status: boolean = true) => {
//     const statusCond =
//         status === true
//             ? `{
//         conditions: [{ operator: EQUAL, field: "status", value: ["1"] }]
//     }`
//             : `
//     {
//         conditions: [{ operator: EQUAL, field: "status", value: ["0"] }]
//     }
//     `;

//     const typeCond = `{
//         conditions: [
//           {operator: EQUAL, field: "vid", value: ["category"]}
//         ]
//     },`;

//     const groupConds = [statusCond, typeCond].filter(d => d);

//     return `{
//             conjunction: AND,
//             groups: [${_.join(groupConds, ",")}]
//         }`;
// };

// const GET_ALL_CATEGORIES = (offset = 0, limit = INFINITE_NUMBER, status: boolean = true) => {
//     return gql`
//         query Categories {
//             query: taxonomyTermQuery (offset: ${offset}, limit: ${limit},
//               filter: ${getAllCategoriesFilter(status)}
//             ) {
//                 entities ${ALL_CATEGORY_QUERY}
//             }
//         }
//     `;
// };

// export const GET_ALL_CATEGORIES_PARAMS = (
//     offset = 0,
//     limit = INFINITE_NUMBER
// ): {
//     query: DocumentNode;
//     options: {
//         skip: boolean;
//     };
// } => {
//     return {
//         query: GET_ALL_CATEGORIES(offset, limit),
//         options: {
//             skip: false
//         }
//     };
// };

const ALL_CATEGORY_QUERY = `
        ${baseCategoryTaxonomy},
        displayName,
        displayType,
        theme,
        faIcon,
        parentId
`;

const GET_ALL_CATEGORIES = () => {
    return gql`
        query Categories {
            result: categories {
                ${ALL_CATEGORY_QUERY}
            }
        }
    `;
};

export const GET_ALL_CATEGORIES_PARAMS = (): {
    query: DocumentNode;
    options: {
        skip: boolean;
    };
} => {
    return {
        query: GET_ALL_CATEGORIES(),
        options: {
            skip: false
        }
    };
};
